import { render, staticRenderFns } from "./AvailableOptionBadges.vue?vue&type=template&id=48f6b4fa&"
import script from "./AvailableOptionBadges.vue?vue&type=script&lang=js&"
export * from "./AvailableOptionBadges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports